var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticStyle:{"height":"100%"},attrs:{"role":"main"}},[_c('Player',{ref:"pl",attrs:{"data":{},"test":true,"advertise-data":_vm.advertiseData},on:{"endplaylist":_vm.endPlaylist}}),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.$refs.pl.play()}}},[_vm._v("zxzz")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }